import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { dropdownMenu } from "@repo/ui/Dropdown/dropdownMenuStyles";
import { AlertDialog, AlertDialogVariant } from "@repo/ui/Modal/alertDialog";
import { CenteredModal } from "@repo/ui/Modal/centeredModal";
import { IconDotsVertical } from "@tabler/icons-react";
import { type FC, useState } from "react";
import {
  DialogTrigger,
  Menu,
  MenuItem,
  MenuTrigger,
  Popover,
} from "react-aria-components";

export interface TrainingParticipantMoreMenuButtonProps {
  onDeleteConfirm: () => void;
}

export const TrainingParticipantMoreMenuButton: FC<
  TrainingParticipantMoreMenuButtonProps
> = (props) => {
  const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);

  return (
    <>
      <MenuTrigger>
        <IconButton
          variant={ButtonVariant.Secondary}
          icon={<IconDotsVertical className="size-5" />}
        />

        <Popover className={dropdownMenu().popover()} placement="bottom end">
          <Menu className={dropdownMenu().menu()}>
            <DialogTrigger>
              <MenuItem
                className={dropdownMenu().item()}
                onAction={() => setIsConfirmingDelete(true)}
              >
                Delete participant
              </MenuItem>
            </DialogTrigger>
          </Menu>
        </Popover>
      </MenuTrigger>

      <CenteredModal
        isOpen={isConfirmingDelete}
        onOpenChange={setIsConfirmingDelete}
        isDismissable
      >
        <AlertDialog
          variant={AlertDialogVariant.Warning}
          title="Delete participant"
          confirmText="Delete participant"
          onConfirm={({ close }) => {
            props.onDeleteConfirm();
            close();
          }}
        >
          The participant's training results and progress for this project will
          be deleted. This action cannot be undone.
        </AlertDialog>
      </CenteredModal>
    </>
  );
};
